<template>
  <global-footer class="footer custom-render">
    <template v-slot:links>

    </template>
    <template v-slot:copyright>
      <div class="copyright">
        Copyright &copy; 2022 北京弘视科技有限公司
      </div>
    </template>
  </global-footer>
</template>

<script>
import { GlobalFooter } from '@ant-design-vue/pro-layout'

export default {
  name: 'ProGlobalFooter',
  components: {
    GlobalFooter
  }
}
</script>
